import NoResultIcon from '@/common/assets/icons/NoResultIcon.svg?react';
import Button from '@/common/components/base/button/Button';
import Typography from '@/common/components/base/typography/Typography';
import MainLayout from '@/common/components/layouts/MainLayout';
import DamagedPointsComponent from '@/common/components/adjusterReport/damagedPoints/DamagedPointsComponent';
import LocalDamagedPoints from '@/common/components/adjusterReport/damagedPoints/LocalDamagedPoints';
import useDamagedPoints from '@/modules/adjusterReportModules/IncidentParticipants/store/damagePoints/useDamagedPoints';
import { ADJUSTER_REPORT_BODY_DAMAGE_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/bodyDamage/bodyDamageLinks';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';

export default () => {
  return (
    <MainLayout title="بیمه گذار / تصاویر" header="closeHeader">
      <BodyDamagedPoints />
    </MainLayout>
  );
};

export const EmptySpace = () => {
  return (
    <Box
      w="100%"
      h="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={16}
    >
      <NoResultIcon />
      <Typography color="black-3" textStyle="b2">
        نقطه ی آسیب‌دیده ای ثبت نشده است.
      </Typography>
    </Box>
  );
};

const BodyDamagedPoints = () => {
  const { damagedPoints } = useDamagedPoints();
  const navigate = useNavigate();
  const { id } = useParams();

  const addDamagedPoints = () => {
    navigate(
      ADJUSTER_REPORT_BODY_DAMAGE_LINKS.BODY_DAMAGE_IMAGES({
        id: id!,
      }).ADJUSTER_VEHICLE.takePhotoGuide,
      { replace: true },
    );
  };

  const skipToGuide = () => {
    navigate(
      ADJUSTER_REPORT_BODY_DAMAGE_LINKS.BODY_DAMAGE_IMAGES({
        id: id!,
      }).ADJUSTER_VEHICLE.takePhotoGuide,
      { replace: true },
    );
  };

  return (
    <DamagedPointsComponent
      needSelectedPoints={false}
      userType="body"
      header={
        <Box mt={24}>
          <Typography color="black-1" textStyle="b2">
            کارشناس محترم، در صورت داشتن نقاط آسیب‌دیده نسبت به ثبت آن اقدام
            نمایید؛ در غیر این صورت می‌توانید این مرحله را رد کنید.
          </Typography>
        </Box>
      }
      pointsList={<LocalDamagedPoints />}
      buttons={
        <Box>
          {damagedPoints?.length > 0 ? (
            <Button fullWidth onClick={addDamagedPoints} mt={40}>
              ثبت
            </Button>
          ) : (
            <Flex gap={8}>
              <Button w="50%" mt={40} variant="outlined" onClick={skipToGuide}>
                رد کردن این مرحله
              </Button>
              <Button w="50%" mt={40} disabled>
                ثبت
              </Button>
            </Flex>
          )}
        </Box>
      }
    />
  );
};
